// Generated by ReScript, PLEASE EDIT WITH CARE

import * as React from "react";
import * as Caml_option from "../../../../node_modules/rescript/lib/es6/caml_option.js";
function IconChevronRight(Props) {
  var className = Props.className;
  var tmp = {
    height: "9",
    width: "6",
    fill: "none",
    viewBox: "0 0 6 9",
    xmlns: "http://www.w3.org/2000/svg"
  };
  if (className !== undefined) {
    tmp.className = Caml_option.valFromOption(className);
  }
  return React.createElement("svg", tmp, React.createElement("path", {
    d: "M0.875 8.81494C0.699219 8.81494 0.542969 8.75635 0.425781 8.63916C0.171875 8.40479 0.171875 7.99463 0.425781 7.76025L3.72656 4.43994L0.425781 1.13916C0.171875 0.904785 0.171875 0.494629 0.425781 0.260254C0.660156 0.00634766 1.07031 0.00634766 1.30469 0.260254L5.05469 4.01025C5.30859 4.24463 5.30859 4.65479 5.05469 4.88916L1.30469 8.63916C1.1875 8.75635 1.03125 8.81494 0.875 8.81494Z",
    fill: "currentColor"
  }));
}
IconChevronRight.displayName = "IconChevronRight";
var make = IconChevronRight;
export { make };
/* react Not a pure module */